var map = {
	"./ArrowLeftCircle.svg": [
		76662,
		6662
	],
	"./ArrowRightCircle.svg": [
		71476,
		1476
	],
	"./Check.svg": [
		98735,
		8735
	],
	"./FacebookLogoRound.svg": [
		12902,
		2902
	],
	"./FlampLogo.svg": [
		46793
	],
	"./GoogleLogo.svg": [
		9924
	],
	"./Pencil.svg": [
		14465,
		4465
	],
	"./Presentation.svg": [
		18506,
		8506
	],
	"./SK-small.svg": [
		85656
	],
	"./SquareArrow.svg": [
		77517,
		7517
	],
	"./TG_icon.svg": [
		22028,
		2028
	],
	"./WA_icon.svg": [
		21630,
		1630
	],
	"./YandexLogo.svg": [
		95252
	],
	"./apartment.svg": [
		69417,
		9417
	],
	"./appstore.svg": [
		98127
	],
	"./arrow-down.svg": [
		36844,
		6844
	],
	"./arrow-right.svg": [
		46357,
		6357
	],
	"./arrow.svg": [
		90174
	],
	"./bank.svg": [
		15528,
		5528
	],
	"./btnAppStore.svg": [
		89241,
		9241
	],
	"./btnPlayStore.svg": [
		94561,
		4561
	],
	"./burger.svg": [
		82386
	],
	"./cards/balance.svg": [
		85256,
		5256
	],
	"./cards/checklist.svg": [
		427,
		427
	],
	"./cards/document.svg": [
		51166,
		1166
	],
	"./cards/factory.svg": [
		55202,
		5202
	],
	"./cards/laptop.svg": [
		73560,
		3560
	],
	"./cards/location.svg": [
		10935,
		935
	],
	"./cards/online-registration.svg": [
		10509,
		509
	],
	"./cards/portfelCard.svg": [
		53018,
		3018
	],
	"./cards/settings.svg": [
		78680,
		8680
	],
	"./cb-logo.svg": [
		24531,
		4531
	],
	"./cbrf logo.svg": [
		273,
		273
	],
	"./check-circle.svg": [
		82233,
		2233
	],
	"./checkCircle.svg": [
		19772,
		9772
	],
	"./checkbox/checked.svg": [
		4260
	],
	"./checkbox/normal.svg": [
		2436
	],
	"./checklist.svg": [
		18764,
		8764
	],
	"./circle-cross.svg": [
		90825
	],
	"./clock.svg": [
		24207,
		4207
	],
	"./cloud-platform.svg": [
		39683,
		9683
	],
	"./commercial.svg": [
		72520,
		2520
	],
	"./cross-2.svg": [
		49923,
		9923
	],
	"./cross.svg": [
		96273
	],
	"./culture.svg": [
		864,
		864
	],
	"./cycle-arrows.svg": [
		10645,
		645
	],
	"./desktop.svg": [
		24298,
		4298
	],
	"./document.svg": [
		97948,
		7948
	],
	"./down-arrow.svg": [
		16723,
		6723
	],
	"./error.svg": [
		28313,
		8313
	],
	"./facebook.svg": [
		3274,
		3353
	],
	"./full-logo-white.svg": [
		58226,
		8226
	],
	"./full-logo.svg": [
		17254
	],
	"./geo.svg": [
		61686,
		1686
	],
	"./googleplay.svg": [
		85667
	],
	"./gosLogo.svg": [
		25504,
		5504
	],
	"./history.svg": [
		46221,
		6221
	],
	"./house.svg": [
		45667,
		5667
	],
	"./icon-case.svg": [
		45367,
		5367
	],
	"./icon-more.svg": [
		43585,
		3585
	],
	"./icon-people.svg": [
		48706,
		8706
	],
	"./iconWhatsApp.svg": [
		36795,
		6795
	],
	"./icon_apartment.svg": [
		91206,
		1206
	],
	"./icon_bg.svg": [
		97601,
		7601
	],
	"./in-shape/briefcase.svg": [
		40363,
		363
	],
	"./in-shape/calendar.svg": [
		85039
	],
	"./in-shape/cash.svg": [
		55710,
		5710
	],
	"./in-shape/charPieSlice.svg": [
		82833,
		2833
	],
	"./in-shape/clock.svg": [
		62837
	],
	"./in-shape/diagram.svg": [
		31343
	],
	"./in-shape/docs.svg": [
		24414,
		4414
	],
	"./in-shape/gearSix.svg": [
		85169,
		5169
	],
	"./in-shape/grow.svg": [
		70745,
		745
	],
	"./in-shape/house.svg": [
		74372
	],
	"./in-shape/instagram.svg": [
		45918,
		5918
	],
	"./in-shape/loan.svg": [
		66529,
		6529
	],
	"./in-shape/office.svg": [
		60706,
		706
	],
	"./in-shape/percent.svg": [
		12725,
		2725
	],
	"./in-shape/percentRound.svg": [
		81243,
		1243
	],
	"./in-shape/prohibit.svg": [
		87959,
		7959
	],
	"./in-shape/rub.svg": [
		33748
	],
	"./in-shape/shield.svg": [
		7569
	],
	"./in-shape/shieldCheck.svg": [
		15303,
		5303
	],
	"./in-shape/shoppingCart.svg": [
		90002,
		2091
	],
	"./in-shape/telegram.svg": [
		99554,
		9554
	],
	"./in-shape/time.svg": [
		91634,
		1634
	],
	"./in-shape/timer.svg": [
		13268,
		3268
	],
	"./in-shape/users.svg": [
		85938,
		5938
	],
	"./in-shape/valt.svg": [
		61163
	],
	"./in-shape/youtube.svg": [
		68429,
		8429
	],
	"./instagram-mini.svg": [
		598,
		598
	],
	"./instagram.svg": [
		27505,
		7505
	],
	"./investOpenTel.svg": [
		85505,
		5505
	],
	"./investOpenYou.svg": [
		68125,
		8125
	],
	"./investor.svg": [
		2744,
		2744
	],
	"./key.svg": [
		30177,
		177
	],
	"./laptop.svg": [
		54532,
		4532
	],
	"./library.svg": [
		27220,
		7220
	],
	"./lock.svg": [
		71280,
		1280
	],
	"./logo-green-sk.svg": [
		16068,
		6068
	],
	"./logoTelegram.svg": [
		20259,
		259
	],
	"./logoVk.svg": [
		38342,
		8342
	],
	"./logoYouTube.svg": [
		69390,
		9390
	],
	"./main-block-adornment.svg": [
		28352
	],
	"./map-pin.svg": [
		69338,
		9338
	],
	"./mobile-phone.svg": [
		24722,
		4722
	],
	"./mobileMenu/about.svg": [
		19592
	],
	"./mobileMenu/banks.svg": [
		68322
	],
	"./mobileMenu/economy.svg": [
		46003
	],
	"./mobileMenu/loan.svg": [
		6139
	],
	"./mobileMenu/menu.svg": [
		55933,
		5933
	],
	"./mobileMenu/notepad.svg": [
		29409
	],
	"./mobileMenu/user.svg": [
		55831
	],
	"./money.svg": [
		7775,
		7775
	],
	"./monitor.svg": [
		97844,
		7844
	],
	"./multiple-owners.svg": [
		71925,
		1925
	],
	"./new-skolkovo.svg": [
		10185
	],
	"./note.svg": [
		81529,
		1529
	],
	"./od.svg": [
		19138
	],
	"./office.svg": [
		58667,
		8719
	],
	"./ok.svg": [
		78167,
		8167
	],
	"./patterns/ProductsLandPages.svg": [
		166,
		166
	],
	"./patterns/StartInvestingFondBgV2.svg": [
		74687,
		4687
	],
	"./patterns/about-investors-bg-mob.svg": [
		66471,
		6471
	],
	"./patterns/about-investors-bg-tablet.svg": [
		80118,
		118
	],
	"./patterns/about-investors-bg.svg": [
		67089,
		7089
	],
	"./patterns/calc-bg-large-desktop.svg": [
		67409,
		7409
	],
	"./patterns/calc-bg-mob.svg": [
		31590,
		1590
	],
	"./patterns/calc-bg.svg": [
		92482,
		2482
	],
	"./patterns/calc-investing-business-bg-mob.svg": [
		13202,
		3202
	],
	"./patterns/calc-investing-business-bg-tablet.svg": [
		10168,
		168
	],
	"./patterns/calc-investing-business-bg.svg": [
		21281,
		1281
	],
	"./patterns/calc-loans-bg-mob.svg": [
		16783,
		6783
	],
	"./patterns/calc-loans-bg-tablet.svg": [
		77920,
		7920
	],
	"./patterns/calc-loans-bg.svg": [
		57954,
		7954
	],
	"./patterns/card-greed-2.svg": [
		13133,
		3133
	],
	"./patterns/card-greed-3.svg": [
		12898,
		2898
	],
	"./patterns/card-greed-4.svg": [
		39740,
		9740
	],
	"./patterns/card-greed-5.svg": [
		60982,
		982
	],
	"./patterns/card-greed-6.svg": [
		95914,
		5914
	],
	"./patterns/card-greed-7.svg": [
		42661,
		2661
	],
	"./patterns/card-greed-8.svg": [
		44540,
		4540
	],
	"./patterns/card-greed-9.svg": [
		74361,
		4361
	],
	"./patterns/ease-savings.svg": [
		14118,
		4118
	],
	"./patterns/easy-investing-bg-mob.svg": [
		16091,
		8154
	],
	"./patterns/easy-investing-bg-tablet.svg": [
		84837,
		4837
	],
	"./patterns/easy-investing-bg.svg": [
		22561,
		2561
	],
	"./patterns/line-bg.svg": [
		77101,
		7101
	],
	"./patterns/loan-form-success.svg": [
		76917
	],
	"./patterns/offer-bg-1.svg": [
		81463,
		1463
	],
	"./patterns/offer-bg-2.svg": [
		58073,
		8073
	],
	"./patterns/offer-bg-3.svg": [
		31136,
		1136
	],
	"./patterns/offer-bg-4.svg": [
		40023,
		23
	],
	"./patterns/our-products-blue-bg.svg": [
		24438,
		4438
	],
	"./patterns/our-products-wheat-bg.svg": [
		9364,
		9364
	],
	"./patterns/pattern-blue.svg": [
		46806
	],
	"./patterns/product-blue-bg.svg": [
		12893,
		2893
	],
	"./patterns/product-green-bg.svg": [
		43308,
		3308
	],
	"./patterns/product-wheat-bg.svg": [
		84555,
		4555
	],
	"./patterns/quote-bg-mob.svg": [
		5912,
		5912
	],
	"./patterns/quote-bg.svg": [
		40426,
		426
	],
	"./patterns/start-investing-bg-mob.svg": [
		10643,
		643
	],
	"./patterns/start-investing-bg.svg": [
		36899,
		6899
	],
	"./patterns/start-investing-fond-bg.svg": [
		9014,
		9014
	],
	"./patterns/waves.svg": [
		29098,
		9098
	],
	"./patterns/zigzag.svg": [
		99016,
		9016
	],
	"./pay-in.svg": [
		64597,
		4597
	],
	"./pay-out.svg": [
		56410,
		6410
	],
	"./payment.svg": [
		62849,
		2849
	],
	"./people.svg": [
		55409,
		5409
	],
	"./percent.svg": [
		7572,
		7572
	],
	"./percents.svg": [
		6891,
		6891
	],
	"./phone.svg": [
		70480,
		480
	],
	"./place.svg": [
		25871,
		5871
	],
	"./platform.svg": [
		7966,
		7966
	],
	"./plus-income.svg": [
		38077,
		8077
	],
	"./portfel.svg": [
		30189,
		189
	],
	"./primeestate-logo.svg": [
		37897,
		7897
	],
	"./purse.svg": [
		99507,
		9507
	],
	"./radio-active.svg": [
		86653
	],
	"./radio-inactive.svg": [
		75974
	],
	"./reload.svg": [
		89579,
		9579
	],
	"./room.svg": [
		95858,
		5858
	],
	"./rub.svg": [
		26351
	],
	"./sad-face.svg": [
		89676,
		9676
	],
	"./safety.svg": [
		10620
	],
	"./sbrf.svg": [
		15135,
		5135
	],
	"./search.svg": [
		11703,
		1703
	],
	"./shieldWarning.svg": [
		36319,
		6319
	],
	"./sign-only-logo.svg": [
		21983
	],
	"./skolkovo.svg": [
		14426
	],
	"./skyfort.svg": [
		11180,
		1180
	],
	"./socials/newOk.svg": [
		50714,
		714
	],
	"./socials/newTikTok.svg": [
		44215,
		4215
	],
	"./socials/newVk.svg": [
		43554,
		3554
	],
	"./socials/newYouTube.svg": [
		18770,
		8770
	],
	"./socials/vk-black.svg": [
		4155
	],
	"./socials/yandex-dzen-black.svg": [
		41962
	],
	"./socials/youtube-black.svg": [
		20401
	],
	"./socials/youtubePlay.svg": [
		1500,
		1500
	],
	"./star.svg": [
		11127,
		1127
	],
	"./statistics.svg": [
		33544,
		3544
	],
	"./success.svg": [
		37821,
		7821
	],
	"./telegram-mini.svg": [
		43171,
		3171
	],
	"./telegram-sign.svg": [
		46050,
		6050
	],
	"./telegram.svg": [
		70686,
		686
	],
	"./time.svg": [
		173,
		173
	],
	"./user-focus.svg": [
		94475,
		4475
	],
	"./user.svg": [
		14292,
		4292
	],
	"./verif-error.svg": [
		29730,
		9730
	],
	"./verif-failed.svg": [
		56780,
		6780
	],
	"./verif-success.svg": [
		59081,
		9081
	],
	"./viber.svg": [
		37706,
		7706
	],
	"./video-play.svg": [
		53142
	],
	"./vk.svg": [
		95086
	],
	"./wallet.svg": [
		98766,
		8766
	],
	"./warning.svg": [
		82150,
		2150
	],
	"./whats-app-2.svg": [
		98706
	],
	"./whats-app.svg": [
		31602,
		1602
	],
	"./withdrawal.svg": [
		46580,
		6580
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 22057;
module.exports = webpackAsyncContext;